import EfIcon from '@elem/ui/ef-icon';
import EfSection from '@elem/ui/ef-section';
import EfSectionLR from '@elem/ui/ef-section-l-r';
import EfSpec from '@elem/ui/ef-spec';
import { useEffect, useRef, useState } from 'react';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function TheComp() {
    const { t } = useLang('power_kits_48v_system');
    const refAni = useRef(null);

    const items = [
        {
            label: <EfIcon pc="https://websiteoss.ecoflow.com/upload/image/1721112169523/aaa1.png" />,
            title: t('M_item1_title'),
            desc: t('M_item1_desc'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1721206515378/pc_Safe%20%26%20Reliable01.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1721206558097/m_Safe%20%26%20Reliable01.jpg',
        },
        {
            title: t('M_item2_title'),
            desc: t('M_item2_desc'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1721714821335/pc_Safe%20%26%20Reliable02.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1721206565822/m_Safe%20%26%20Reliable02.jpg',
        },
        {
            title: t('M_item3_title'),
            desc: t('M_item3_desc'),
            // pc: 'https://websiteoss.ecoflow.com/upload/image/1721206533728/pc_Safe%20%26%20Reliable03.jpg',
            // h5: 'https://websiteoss.ecoflow.com/upload/image/1721206574123/m_Safe%20%26%20Reliable03.jpg',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1725352626093/20240903-163514.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1725352592274/20240903-163504.jpg',
        },
    ];

    useEffect(() => {
        if (typeof window !== 'undefined') {
            AniContainer.create({
                triggerElement: `.${styles.TheComp}`,
                triggerHook: 1,
                asyncFromTo: [
                    [`.${styles.TheComp} .item-1`, { opacity: 1 }, { opacity: 1 }, 0.05],
                    [`.${styles.TheComp} .item-1`, { opacity: 1 }, { opacity: 0 }, 0.05],
                    [`.${styles.TheComp} .item-2`, { opacity: 0 }, { opacity: 1 }, 0.05],
                    [`.${styles.TheComp} .item-2`, { opacity: 1 }, { opacity: 0 }, 0.05],
                    [`.${styles.TheComp} .item-3`, { opacity: 0 }, { opacity: 1 }, 0.05],
                ],
                asyncTimeLine: [0, 0.5, 0.5, 1, 1],
                offset: '100%',
                duration: '200%',
            });
        }
    }, []);

    return (
        <div className={styles.TheComp}>
            <div className="sticky-box">
                <div className="box-inner">
                    <EfSection hasAnimation={false} label={t('M_label')} title={t('M_title')} />
                    <ul className="items">
                        {items?.map((item: any, k: number) => (
                            <li className={`item item-${k + 1}`} key={k}>
                                <EfSectionLR {...item} />
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
}
